<template>
  <b-container class="mw-100">
    <b-row v-show="enabledLinks.length !== 0" align-h="center">
      <b-col cols="auto">
        <h6 class="d-inline-flex mb-0 c-l-gray" v-if="!isMobile && !hideLabel">{{enabledLinks.length === 1 ? $tc('message.shortcut', 1) : $tc('message.shortcut', 2)}}</h6>
        <i class="fas fa-hand-point-right c-l-gray fa-lg"/>
      </b-col>

      <b-col>
        <a v-for="(link, index) in enabledLinks" :key="index" class="">
          <h6 :class="`c-green hover-enabled h-c-blue mb-0 ${isMobile ? 'd-block' : 'd-inline-flex'}`" @click="clickedLink(link)">{{link.title}}</h6>
          <div class="fas fa-circle fa-xs c-l-gray mr-2 ml-1 my-custom-dot" v-show="enabledLinks.length - 1 !== link.index && !isMobile"></div>
        </a>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import routeViews from '../../router-views'
import Vue from 'vue'

export default {
  name: 'LinkList',
  props: ['value', 'hideLabel'],
  watch: {
    value (newVal) {
      this.enabledLinks = this.getLinks(newVal)
    }
  },
  mounted () {
    this.$root.$on('change-links', links => {
      this.enabledLinks = this.getLinks(links)
    })
    this.$root.$on('reset-links', () => {
      this.enabledLinks = []
    })
    this.$root.$on('resize', () => {
      this.checkWindowWidth()
    })
  },
  data () {
    return {
      enabledLinks: this.value || [],
      to: {},
      from: {},
      isMobile: false
    }
  },
  methods: {
    clickedLink (link) {
      this.$emit('clicked-link', link)
    },
    getLinks (links) {
      const editedLinks = []
      const allItems = routeViews.allItems

      if (links && links.length !== 0 && this && this.$tc) {
        links.forEach((link, index) => {
          const editedLink = link
          const foundedLink = Vue.getConfigByRouteItem({
            path: link.path || link.href,
            params: link.href.params
          })

          if (foundedLink) {
            let title = ''
            const foundedItem = this.findRoute(foundedLink, allItems)
            if (foundedItem && foundedItem.title) {
              foundedItem.title.forEach((chunk, index) => {
                if (chunk && chunk.option) {
                  title += index === 0 ? this.$tc(chunk.option, chunk.num) : ` ${this.$tc(chunk.option, chunk.num).toLowerCase()}`
                }
              })
            }

            editedLink.title = title || foundedLink.title
            editedLink.index = index
            editedLinks.push(editedLink)
          }
        })
      }

      return editedLinks
    },
    findRoute (item, routes) {
      if (!routes || routes.length === 0) return null
      const path = item.path

      let foundedItem = null
      routes.forEach(route => {
        if ((route.path === path && path) ||
          (route.title === item.title &&
            route.componentName === item.componentName && !path)) foundedItem = route
        else if (route.child && route.child.length !== 0 && !foundedItem) {
          foundedItem = this.findRoute(item, route.child)
        }
      })
      return foundedItem
    },
    checkWindowWidth () {
      const size = Vue.myGetWindowSize()
      this.isMobile = (size !== 'md' && size !== 'lg' && size !== 'xl')
    }
  }
}
</script>

<style scoped>
  .my-custom-dot {
    font-size: 8px;
    bottom: 3px;
    position: relative;
  }
</style>
